<template>
  <div class="container" id="vendor-rate">
    <nav class="add-navigation">
      <div @click="$emit('close')" class="back-link">
        <svg class="icon" width="30px" height="30px" viewBox="0 0 30 30" version="1.1">
          <path
            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
            id="path-1"
          />
        </svg>
        <p>Back to Vendor Rate</p>
      </div>

      <div class="buttons-wrapper">
        <div @click="$emit('close')" class="secondary-button">
          <secondary-button>Cancel</secondary-button>
        </div>
        <div class="primary-button">
          <primary-button @click.native="addVendorRate">Add Vendor Rate</primary-button>
        </div>
      </div>
    </nav>
    <div
      class="header_name"
      v-if="rateTable.vendor_product"
    >{{rateTable.vendor_product.vendor_product_name}} Rates</div>
    <div class="add-container">
      <span class="container-title">Add Vendor Rate</span>
      <div class="col-wrapper">
        <div class="col">
          <primary-select
            v-if="rateTable.rate_table_type"
            type="text"
            name="rate table type"
            class="type type-select"
            v-validate="'required'"
            :value="rateTable.rate_table_type"
            @input="handleRateTableTypeChange"
            :class="{'input': true, 'is-danger': errors.has('rate table type')}"
            placeholder="Rate table type"
            :options="rateTypes"
          />
          <div class="help is-danger" v-if="errors.has('rate table type')">This field is required</div>
        </div>
      </div>

      <!-- Add new rates -->
      <div
        class="col-wrapper"
        v-if="rateTable.rate_table_uuid"
        v-for="(rate, idx) in adding_rates"
        :key="idx + 9999"
      >
        <!-- <div class="row ml-0" style="width:100%;"> -->
        <div class="row ml-0">
          <template v-if="rateTable.rate_table_type === 'MNCMCC'">
            <div class="col">
              <primary-select
                type="text"
                :name="'country_'+idx"
                :ref="'country_'+idx"
                :data-vv-as="'country'"
                label_name="country"
                v-model="adding_rates[idx].code"
                v-validate="!editRatesExists ? 'required' : ''"
                @input="handleCodeChange($event, idx, 'adding')"
                :class="{'input': true, 'is-danger': errors.has('country_'+idx)}"
                placeholder="Country"
              >
                <option
                  :value="i.country_uuid"
                  v-for="(i, country_uuid) in countries"
                  :key="country_uuid"
                >{{i.nice_name ? i.nice_name : i.name}}</option>
              </primary-select>
              <div
                class="help is-danger"
                v-if="errors.has('country_'+idx)"
              >{{ errors.first('country_'+idx) }}</div>
            </div>

            <div class="col">
              <primary-select
                type="text"
                :name="'operator_'+idx"
                :ref="'operator_'+idx"
                :data-vv-as="'operator'"
                label_name="operator"
                v-model="adding_rates[idx].mobile_network_uuid"
                v-validate="!editRatesExists ? 'required' : ''"
                :class="{'input': true, 'is-danger': errors.has('operator_'+idx)}"
                placeholder="Company"
              >
                <option
                  :value="i.mobile_network_uuid"
                  v-for="(i, mobile_network_uuid) in mobileNetworks[idx]"
                  :key="mobile_network_uuid"
                >{{i.network_name}}</option>
              </primary-select>
              <div
                class="help is-danger"
                v-if="errors.has('operator_'+idx)"
              >{{ errors.first('operator_'+idx) }}</div>
            </div>
          </template>
          <div class="col" v-if="rateTable.rate_table_type === 'prefix'">
            <primary-input
              type="text"
              :name="'code_'+idx"
              :ref="'code_'+idx"
              :data-vv-as="'code'"
              label_name="code"
              v-model="adding_rates[idx].code"
              v-validate="!editRatesExists ? 'required' : ''"
              :class="{'input': true, 'is-danger': errors.has('code_'+idx)}"
              placeholder="Enter code"
            />
            <div class="help is-danger" v-if="errors.has('code_'+idx)">This field is required</div>
          </div>

          <div class="col">
            <primary-input
              type="text"
              :name="'rate_'+idx"
              :ref="'rate_'+idx"
              :data-vv-as="'rate'"
              label_name="rate"
              v-model="adding_rates[idx].price"
              v-validate="!editRatesExists ? 'required': ''"
              :class="{'input': true, 'is-danger': errors.has('rate_'+idx)}"
              placeholder="Enter rate"
            />
            <div class="help is-danger" v-if="errors.has('rate_'+idx)">This field is required</div>
          </div>
        </div>
        <div v-if="idx > 0" @click="removeAddedRate(idx)" class="remove-added-rate">
          <svg width="30px" height="30px" viewBox="0 0 30 30" version="1.1" class="icon">
            <path
              transform="translate(14.977556, 14.977594) rotate(45.000000) translate(-14.977556, -14.977594) "
              d="M14.9776692,5 C9.47601504,5 5,9.47593985 5,14.977594 C5,20.4792481 9.47593985,24.955188 14.977594,24.955188 C20.4792481,24.955188 24.9551128,20.4792481 24.9551128,14.977594 C24.9551128,9.47593985 20.4793233,5 14.9776692,5 Z M14.9776692,23.8273684 C10.0978195,23.8273684 6.12781955,19.8574436 6.12781955,14.977594 C6.12781955,10.0977444 10.0978195,6.12781955 14.9776692,6.12781955 C19.8573684,6.12781955 23.8273684,10.0978195 23.8273684,14.977594 C23.8273684,19.8573684 19.8573684,23.8273684 14.9776692,23.8273684 Z M18.4926901,14.3550877 L15.7499108,14.3550877 L15.7499108,11.6578947 C15.7499108,11.2944737 15.4504601,11 15.0808967,11 C14.7113333,11 14.4118826,11.2944737 14.4118826,11.6578947 L14.4118826,14.3550877 L11.6690141,14.3550877 C11.2994507,14.3550877 11,14.6495614 11,15.0129825 C11,15.3764035 11.2994507,15.6708772 11.6690141,15.6708772 L14.4117934,15.6708772 L14.4117934,18.3681579 C14.4117934,18.7315789 14.7112441,19.0260526 15.0808075,19.0260526 C15.4503709,19.0260526 15.7498216,18.7315789 15.7498216,18.3681579 L15.7498216,15.6708772 L18.4926009,15.6708772 C18.8621643,15.6708772 19.161615,15.3764035 19.161615,15.0129825 C19.161615,14.6495614 18.8621643,14.3550877 18.4926901,14.3550877 Z"
              id="path-1"
            />
          </svg>
        </div>
      </div>
      <div class="col-wrapper" style="margin-top: 0;">
        <!-- <div class="row ml-0" style="width:100%;"> -->
        <div class="row ml-0">
          <div class="col">
            <div @click="addNewRate" class="add-new-rates">
              <svg width="30px" height="30px" viewBox="0 0 30 30" version="1.1" class="icon">
                <path
                  d="M14.9776692,5 C9.47601504,5 5,9.47593985 5,14.977594 C5,20.4792481 9.47593985,24.955188 14.977594,24.955188 C20.4792481,24.955188 24.9551128,20.4792481 24.9551128,14.977594 C24.9551128,9.47593985 20.4793233,5 14.9776692,5 Z M14.9776692,23.8273684 C10.0978195,23.8273684 6.12781955,19.8574436 6.12781955,14.977594 C6.12781955,10.0977444 10.0978195,6.12781955 14.9776692,6.12781955 C19.8573684,6.12781955 23.8273684,10.0978195 23.8273684,14.977594 C23.8273684,19.8573684 19.8573684,23.8273684 14.9776692,23.8273684 Z M18.4926901,14.3550877 L15.7499108,14.3550877 L15.7499108,11.6578947 C15.7499108,11.2944737 15.4504601,11 15.0808967,11 C14.7113333,11 14.4118826,11.2944737 14.4118826,11.6578947 L14.4118826,14.3550877 L11.6690141,14.3550877 C11.2994507,14.3550877 11,14.6495614 11,15.0129825 C11,15.3764035 11.2994507,15.6708772 11.6690141,15.6708772 L14.4117934,15.6708772 L14.4117934,18.3681579 C14.4117934,18.7315789 14.7112441,19.0260526 15.0808075,19.0260526 C15.4503709,19.0260526 15.7498216,18.7315789 15.7498216,18.3681579 L15.7498216,15.6708772 L18.4926009,15.6708772 C18.8621643,15.6708772 19.161615,15.3764035 19.161615,15.0129825 C19.161615,14.6495614 18.8621643,14.3550877 18.4926901,14.3550877 Z"
                  id="path-1"
                />
              </svg>
              <p>Add Rate</p>
            </div>
          </div>
        </div>
      </div>
      <span class="container-title" v-if="editRatesExists">Edit Vendor Rates</span>
      <span class="container-title" v-else>No rates found</span>

      <!-- Edit previous rates -->
      <div
        class="col-wrapper"
        v-if="editRatesExists"
        v-for="(editing_rate, idx) in editing_rates"
        :key="idx"
      >
        <!-- <div class="row ml-0" style="width:100%;"> -->
        <div class="row ml-0">
          <template v-if="rateTable.rate_table_type === 'MNCMCC'">
            <div class="col">
              <primary-select
                type="text"
                :name="'country'+idx"
                label_name="country"
                :value="editing_rates[idx].code"
                @input="handleCodeChange($event, idx, 'editing')"
                :class="{'input': true, 'is-danger': errors.has('country'+idx)}"
                placeholder="Country"
              >
                <option
                  :value="i.country_uuid"
                  v-for="(i, country_uuid) in countries"
                  :key="country_uuid"
                >{{i.nice_name ? i.nice_name : i.name}}</option>
              </primary-select>
              <div
                class="help is-danger"
                v-if="errors.has('country'+idx)"
              >{{ errors.first('country'+idx) }}</div>
            </div>

            <div class="col">
              <primary-select
                type="text"
                :name="'operator'+idx"
                label_name="operator"
                v-model="editing_rates[idx].mobile_network_uuid"
                :class="{'input': true, 'is-danger': errors.has('operator'+idx)}"
                placeholder="Company"
              >
                <option
                  :value="i.mobile_network_uuid"
                  v-for="(i, mobile_network_uuid) in mobileNetworksEdit[idx]"
                  :key="mobile_network_uuid"
                >{{i.network_name}}</option>
              </primary-select>
              <div
                class="help is-danger"
                v-if="errors.has('operator'+idx)"
              >{{ errors.first('operator'+idx) }}</div>
            </div>
          </template>
          <div class="col" v-if="rateTable.rate_table_type === 'prefix'">
            <primary-input
              type="text"
              :name="'code'+idx"
              label_name="code"
              v-model="editing_rates[idx].code"
              v-validate="'required'"
              :class="{'input': true, 'is-danger': errors.has('code'+idx)}"
              placeholder="Enter code"
            />
            <div class="help is-danger" v-if="errors.has('code'+idx)">This field is required</div>
          </div>

          <div class="col">
            <primary-input
              type="text"
              :name="'rate'+idx"
              label_name="rate"
              v-model="editing_rates[idx].price"
              v-validate="'required'"
              :class="{'input': true, 'is-danger': errors.has('rate'+idx)}"
              placeholder="Enter rate"
            />
            <div class="help is-danger" v-if="errors.has('rate'+idx)">This field is required</div>
          </div>
          <!-- <div @click="removeRate(editing_rates[idx].rate_uuid)" class="remove-added-rate">
            <svg width="30px" height="30px" viewBox="0 0 30 30" version="1.1" class="icon">
              <path
                transform="translate(14.977556, 14.977594) rotate(45.000000) translate(-14.977556, -14.977594) "
                d="M14.9776692,5 C9.47601504,5 5,9.47593985 5,14.977594 C5,20.4792481 9.47593985,24.955188 14.977594,24.955188 C20.4792481,24.955188 24.9551128,20.4792481 24.9551128,14.977594 C24.9551128,9.47593985 20.4793233,5 14.9776692,5 Z M14.9776692,23.8273684 C10.0978195,23.8273684 6.12781955,19.8574436 6.12781955,14.977594 C6.12781955,10.0977444 10.0978195,6.12781955 14.9776692,6.12781955 C19.8573684,6.12781955 23.8273684,10.0978195 23.8273684,14.977594 C23.8273684,19.8573684 19.8573684,23.8273684 14.9776692,23.8273684 Z M18.4926901,14.3550877 L15.7499108,14.3550877 L15.7499108,11.6578947 C15.7499108,11.2944737 15.4504601,11 15.0808967,11 C14.7113333,11 14.4118826,11.2944737 14.4118826,11.6578947 L14.4118826,14.3550877 L11.6690141,14.3550877 C11.2994507,14.3550877 11,14.6495614 11,15.0129825 C11,15.3764035 11.2994507,15.6708772 11.6690141,15.6708772 L14.4117934,15.6708772 L14.4117934,18.3681579 C14.4117934,18.7315789 14.7112441,19.0260526 15.0808075,19.0260526 C15.4503709,19.0260526 15.7498216,18.7315789 15.7498216,18.3681579 L15.7498216,15.6708772 L18.4926009,15.6708772 C18.8621643,15.6708772 19.161615,15.3764035 19.161615,15.0129825 C19.161615,14.6495614 18.8621643,14.3550877 18.4926901,14.3550877 Z"
                id="path-1"
              />
            </svg>
          </div>-->
        </div>
        <div @click="removeRate(editing_rates[idx].rate_uuid)" class="remove-added-rate">
          <svg width="30px" height="30px" viewBox="0 0 30 30" version="1.1" class="icon">
            <path
              transform="translate(14.977556, 14.977594) rotate(45.000000) translate(-14.977556, -14.977594) "
              d="M14.9776692,5 C9.47601504,5 5,9.47593985 5,14.977594 C5,20.4792481 9.47593985,24.955188 14.977594,24.955188 C20.4792481,24.955188 24.9551128,20.4792481 24.9551128,14.977594 C24.9551128,9.47593985 20.4793233,5 14.9776692,5 Z M14.9776692,23.8273684 C10.0978195,23.8273684 6.12781955,19.8574436 6.12781955,14.977594 C6.12781955,10.0977444 10.0978195,6.12781955 14.9776692,6.12781955 C19.8573684,6.12781955 23.8273684,10.0978195 23.8273684,14.977594 C23.8273684,19.8573684 19.8573684,23.8273684 14.9776692,23.8273684 Z M18.4926901,14.3550877 L15.7499108,14.3550877 L15.7499108,11.6578947 C15.7499108,11.2944737 15.4504601,11 15.0808967,11 C14.7113333,11 14.4118826,11.2944737 14.4118826,11.6578947 L14.4118826,14.3550877 L11.6690141,14.3550877 C11.2994507,14.3550877 11,14.6495614 11,15.0129825 C11,15.3764035 11.2994507,15.6708772 11.6690141,15.6708772 L14.4117934,15.6708772 L14.4117934,18.3681579 C14.4117934,18.7315789 14.7112441,19.0260526 15.0808075,19.0260526 C15.4503709,19.0260526 15.7498216,18.7315789 15.7498216,18.3681579 L15.7498216,15.6708772 L18.4926009,15.6708772 C18.8621643,15.6708772 19.161615,15.3764035 19.161615,15.0129825 C19.161615,14.6495614 18.8621643,14.3550877 18.4926901,14.3550877 Z"
              id="path-1"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
  },
  props: ["rate_table_uuid"],
  data: () => ({
    validateError: null,
    rateTypes: [
      { name: "Prefix", value: "prefix" },
      /*{name: 'LRN', value: 'LRN'},*/ { name: "MNCMCC", value: "MNCMCC" },
    ],
    type: ["Virtual", "Landline", "Mobile", "Toll Free"],
    didType: ["ANI", "DNIS"],
    rate: {
      code: null,
      mobile_network_uuid: null,
      price: null,
    },
    vendorId: null,
    countries: [],
    product: null,
    editing_rates: [],
    adding_rates: [
      {
        code: null,
        mobile_network_uuid: null,
        price: null,
      },
    ],
    mobileNetworks: [], // for add rate
    mobileNetworksEdit: [], // for edit rate
    editRatesExists: false,
  }),
  computed: {
    ...mapGetters({
      vendorProducts: "vendorProduct/getVendorProducts",
      totalVendorProducts: "vendorProduct/getTotal",
      rateTable: "rateTable/getRateTable",
    }),
    products() {
      return this.vendorProducts.map((product) => ({
        name: product.vendor_product_name,
        value: product.vendor_product_uuid,
      }));
    },
  },
  async created() {
    this.vendorId = this.$route.params.id;
    this.getCountryList();
    this.getAllVendorProducts();
    await this.viewRateTable(this.rate_table_uuid);

    const res = await this.getRateList({
      rate_table_uuid: this.rate_table_uuid,
    });
    this.editing_rates = res.items;
    console.log(this.rateTable);

    if (this.editing_rates) {
      this.editing_rates.map((rate, idx) => {
        this.getCountryList();
        this.getMobileNetworkList(rate.code, idx, false, "editing");
      });
      this.editRatesExists = true;
    }
  },
  methods: {
    ...mapActions({
      viewVendorProducts: "vendorProduct/getVendorProductList",
      addRate: "rates/addRate",
      editRateTable: "rateTable/editRateTable",
      viewMobileNetworksNoCommits: "mobileNetwork/GetMobileNetworksNoCommit",
      viewRateTable: "rateTable/getRateTable",
      viewRateTableNoCommit: "rateTable/getRateTableNoCommit",
      getRateList: "rates/getRateList",
      deleteRate: "rates/deleteRate",
    }),
    async removeRate(rate_uuid) {
      await this.deleteRate(rate_uuid);
      this.editing_rates = this.editing_rates.filter(
        (rate) => rate.rate_uuid !== rate_uuid
      );
      this.$success("Rate have been deleted.");
      if (!this.editing_rates.length) {
        this.editRatesExists = false;
      }
    },
    removeAddedRate: function (idx) {
      if (this.adding_rates[idx]) {
        this.adding_rates.splice(idx, 1);
      }
    },
    addNewRate: function () {
      this.adding_rates.push({
        code: null,
        mobile_network_uuid: null,
        price: null,
      });
    },
    async handleRateTableTypeChange(v) {
      this.rateTable.rate_table_type = v;
      const res = await this.getRateList({
        rate_table_uuid: this.rate_table_uuid,
      });
      this.editing_rates = res.items;
      const { rate_table_type } = await this.viewRateTableNoCommit(
        this.rate_table_uuid
      );
      this.editRatesExists = true;
      if (rate_table_type && v !== rate_table_type) {
        this.editing_rates = [];
        this.editRatesExists = false;
      }
      this.adding_rates = [
        {
          code: null,
          mobile_network_uuid: null,
          price: null,
        },
      ];

      if (this.rateTable.rate_table_type === "prefix" && this.rateTable.code) {
        this.getMobileNetworkList(this.rate.code, null, true, "editing");
      }
    },
    async handleCodeChange(v, idx = null, type = "editing") {
      // If type editing its mean we change editing part
      if (type === "editing") {
        this.editing_rates[idx].code = v;
      } else {
        this.adding_rates[idx].code = v;
      }

      this.getMobileNetworkList(v, idx, true, type);
    },
    async getCountryList(idx = null) {
      const { items } = await this.$store.dispatch("getCountryList", {});
      this.countries = items;
    },
    async getAllVendorProducts() {
      await this.viewVendorProducts({ vendorId: this.vendorId });
      await this.viewVendorProducts({
        perPage: this.totalVendorProducts,
        vendorId: this.vendorId,
      });
    },
    async getMobileNetworkList(
      id,
      idx = null,
      changed = false,
      type = "editing",
    ) {
      const iso3 = this.countries.filter(e => {
        if(e.country_uuid == id) {
          return e
        }
      });

      const res = await this.viewMobileNetworksNoCommits({
        // country_code: id,
        // per_page: 9999, // to bring all data
        id: iso3[0].iso3
      });

      // If type editing its mean we change editing part
      if (type === "editing") {
        this.mobileNetworksEdit[idx] = res.items;
        // If country changed from user, make first network as default selected
        if (changed) {
          this.editing_rates[idx].mobile_network_uuid =
            res.items && res.items.length
              ? res.items[0].mobile_network_uuid
              : null;
        }
      } else {
        this.mobileNetworks[idx] = res.items;
        // If country changed from user, make first network as default selected
        if (changed) {
          this.adding_rates[idx].mobile_network_uuid =
            res.items && res.items.length
              ? res.items[0].mobile_network_uuid
              : null;
        }
      }
    },
    async addVendorRate() {
      const valid = await this.$validator.validate();

      if (!valid) {
        return;
      }
      let data = []; // Add new rate fields

      if (this.adding_rates) {
        data = [...this.adding_rates];
      }

      if (this.editRatesExists) {
        this.editing_rates.map((rate) => {
          data.push({
            code: rate.code,
            price: rate.price,
            mobile_network_uuid: rate.mobile_network_uuid,
          });
        });
      }

      data = data.map((item, idx) => {
        if (this.rateTable.rate_table_type === "prefix") {
          if (item.code == null) delete item.code;
          if (item.price == null) delete item.price;
          delete item.mobile_network_uuid;
        }
        if (this.rateTable.rate_table_type === "MNCMCC") {
          if (item.mobile_network_uuid == null) delete item.mobile_network_uuid;
          if (item.price == null) delete item.price;
          if (item.code == null) delete item.code;
        }
        if (Object.keys(item).length) {
          return item;
        }
      });
      data = data.filter(function (el) {
        return el != null;
      });

      this.editRateTable({
        data: { rate_table_type: this.rateTable.rate_table_type, rates: data },
        rate_table_uuid: this.rateTable.rate_table_uuid,
      })
        .then(() => {
          this.$success("Rate have been saved.");
          this.$emit("close");
        })
        .catch((err) => {
          this.$error(err);
        });
    },
  },
};
</script>

<style>
#vendor-rate .primary-select-wrapper select {
  padding-right: 15px;
}
</style>

<style scoped>
.header_name {
  padding: 0px 15px;
  font-size: 16px;
  font-weight: 600;
}
.remove-added-rate {
  cursor: pointer;
  fill: #55616e;
  height: 30px;
  margin-right: 12.5px;
  margin-left: 12.5px;
  width: 30px;
  margin-top: 25.5px;
}
.add-container {
  overflow-y: auto;
}
.add-new-rates {
  cursor: pointer;
  margin-bottom: 10px;
  height: 30px;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  fill: #55616e;
  display: flex;
  align-items: center;
  align-self: flex-start;
}
.add-new-rates p {
  margin-left: 7px;
  margin-bottom: 0;
  color: #55616e;
  font-family: "Helvetica Neue";
  font-size: 14px;
  line-height: 25px;
}
</style>

<style lang="scss" scoped>
.container {
  font-family: "Helvetica Neue";
  padding: 0 20px;
  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin-bottom: 0;
      }
    }
    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      .primary-button {
        height: 40px;
        width: 180px;
      }
      .secondary-button {
        height: 40px;
        width: 90px;
        margin-right: 20px;
      }
    }
  }
  .add-container {
    flex-direction: column;
    align-items: center;
    height: 375px;
    background-color: #ffffff;
    padding-top: 15px;

    .container-title {
      height: 30px;
      width: 432px;
      color: #000000;
      font-size: 16px;
      font-weight: 500;
      line-height: 30px;
      padding: 15px 0 15px 15px;
    }
    .col-wrapper {
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding-left: 15px;
      margin-top: 20px;

      .row {
        display: flex;
        justify-content: space-between;
        width: calc(100% - 55px);

        .col {
          margin-right: 20px;

          &:last-child {
            margin-right: 0;
          }
        }
      }
      .col {
        width: 100%;
        margin-right: 55px;
        padding: 0;

        .input {
          margin-bottom: 20px;
        }
        .field {
          p.pimary-input-title {
            color: #000000;
            font-family: "Helvetica Neue";
            font-size: 12px;
            font-weight: 900;
          }
        }
        .upload-photo,
        #dropzone {
          min-height: 285px;
          min-height: 285px;
          border-radius: 4px;
          width: 100%;
          .dz-image {
            padding: 5px;
            img {
              height: 150px;
              width: 150px;
              border-radius: 50px;
            }
          }
        }
        p.pimary-input-title {
          color: #000000;
          font-family: "Helvetica Neue";
          font-size: 12px;
          font-weight: 900;
        }
        .upload-contaioner {
          border: 1px solid #5171f3;
          border-radius: 4px;
          background-color: #ffffff;
          height: 265px;
          border-style: dashed;
          margin-right: 15px;
          position: relative;
          input[type="file"] {
            position: absolute;
            height: 36px;
            width: 136px;
            opacity: 0;
            cursor: pointer;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            -ms-transform: translate(-50%, -50%); /* IE 9 fix */
            z-index: 1;
          }
          .upload-button {
            height: 36px;
            width: 136px;
            border-radius: 4px;
            background-color: #51a3f3;
            margin: 0;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
    .email-input {
      margin-bottom: 20px;
    }
    .password-input {
      margin-bottom: 30px;
    }
    .first {
      margin-bottom: 30px;
      .remember-me {
        display: flex;
        align-items: center;
        input {
          margin-right: 5px;
        }
      }
    }
  }
}
</style>


